import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import iconPremium from '../../assets/icons/premium.png';
import off40 from '../../assets/icons/40off.png';
import off20 from '../../assets/icons/20off.png';
import { useCountry } from '../../contexts/CountryContext';
import { formatCurrency } from '../../config/countries';
import './styles.css';

export default function BodyPlans(props){
  const { t } = useTranslation();
  const { selectedCountry, countryConfig } = useCountry();
  const [planModality, setPlanModality] = useState("Individual");

  const formatPrice = (value) => {
    return formatCurrency(value, selectedCountry);
  };

  const getPlanPrice = (type, period) => {
    const modality = planModality === "Individual" ? "individual" : "team";
    return countryConfig.plans[modality][period][type];
  };
 
    return (
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h1>{t('index.plans')}</h1>
              <span>{t('index.plansDescription')}</span>  
              <br /><br /><br />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-6 offset-md-3 text-center">
              <div className="divButtonSelect">
                <div className={planModality === "Individual" ? "itemButtonSelect active text-center" : "itemButtonSelect text-center" } onClick={() => setPlanModality("Individual")} > 
                  <span>{t('index.individual')}</span>
                </div>
                <div className={planModality === "Equipe" ? "itemButtonSelect active text-center" : "itemButtonSelect text-center" } onClick={() => setPlanModality("Equipe")}> 
                  <span>{t('index.team')}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-4 text-center">
              <img src={off40} className="imgDiscount"/>
              <div className="itemPlan active text-center">
                <div className="text-center">
                  <img src={iconPremium} width="80"/>
                  <p className="title">{planModality === "Individual" ? t('index.annualPlan') : t('index.annualPlanTeam')}</p>
                </div>
                <hr />
                <ul className="list-unstyled text-left" style={{margin: 15}}>
                  <li><i>✔</i> {t('index.planFeatures.patientManagement')}</li> 
                  <li><i>✔</i> {t('index.planFeatures.appointmentManagement')}</li> 
                  <li><i>✔</i> {t('index.planFeatures.onlineScheduling')}</li>
                  <li><i>✔</i> {t('index.planFeatures.irisAnalysis')}</li>
                  <li><i>✔</i> {t('index.planFeatures.cloudStorage')}</li> 
                  <li><i>✔</i> {t('index.planFeatures.multipleDevices')}</li> 
                  <li><i>✔</i> {t('index.planFeatures.webApp')}</li> 
                  <li><i>✔</i> {t('index.planFeatures.futureUpdates')}</li>
                  <li><i>✔</i> {planModality === "Individual" ? t('index.planFeatures.oneUser') : <b>{t('index.planFeatures.fiveUsers')}</b>}</li>
                  <li><i>✔</i> <b>{t('index.planFeatures.thirtyDaysFree')}</b></li>
                  <div style={{marginTop: 10}}>
                    <span>{t('index.planFeatures.bonus')}</span>
                    <div className="text-center">
                      <a href="https://ilinks.com.br" target="_Blank">
                        <img src="https://ilinks.com.br/personalizar-texto/images/logo.png" width="80px"/>
                      </a>
                      <div>{t('index.planFeatures.oneYearPremium')}</div>
                    </div>
                  </div>
                  <hr />
                  <li className="priceMouth">
                    <div className="text-center">
                      {countryConfig.currency.symbol} <span className="oldPrice">{formatPrice(getPlanPrice('original', 'annual'))}</span>/{t('index.month')}
                    </div>
                    <div className="text-center">
                      {countryConfig.currency.symbol}<strong className="amount"><span className="big" id="valorMensal"> {formatPrice(getPlanPrice('discounted', 'annual'))}</span></strong>/{t('index.month')} 
                    </div>
                  </li>
                </ul>
                <button onClick={() => window.open(planModality === "Individual" ? "https://buy.stripe.com/14k7vc6YP3c35y09AC" : "https://buy.stripe.com/9AQ2aSfvl7sje4w005", "_self")} className="btn btn-default col-12 col-md-10">
                  <span style={{marginLeft: 5}}>{t('index.getPlan')}</span>
                </button>
                <div className="text-center" style={{paddingTop: 15, marginBottom: -18}}>
                  <span className="text-center obs">* {t('index.paymentInfo', { value: formatPrice(getPlanPrice('total', 'annual')), period: t('index.annual') })}</span>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 text-center">
              <img src={off20} className="imgDiscount"/>
              <div className="itemPlan text-center">
                <div className="text-center">
                  <img src={iconPremium} width="80"/>
                  <p className="title">{planModality === "Individual" ? t('index.semiannualPlan') : t('index.semiannualPlanTeam')}</p>
                </div>
                <hr />
                <ul className="list-unstyled text-left" style={{margin: 15}}>
                  <li><i>✔</i> {t('index.planFeatures.patientManagement')}</li> 
                  <li><i>✔</i> {t('index.planFeatures.appointmentManagement')}</li> 
                  <li><i>✔</i> {t('index.planFeatures.onlineScheduling')}</li>
                  <li><i>✔</i> {t('index.planFeatures.irisAnalysis')}</li>
                  <li><i>✔</i> {t('index.planFeatures.cloudStorage')}</li> 
                  <li><i>✔</i> {t('index.planFeatures.multipleDevices')}</li> 
                  <li><i>✔</i> {t('index.planFeatures.webApp')}</li> 
                  <li><i>✔</i> {t('index.planFeatures.futureUpdates')}</li>
                  <li><i>✔</i> {planModality === "Individual" ? t('index.planFeatures.oneUser') : <b>{t('index.planFeatures.fiveUsers')}</b>}</li>
                  <li><i>✔</i> <b>{t('index.planFeatures.fourteenDaysFree')}</b></li>
                  <div style={{marginTop: 10}}>
                    <span>{t('index.planFeatures.bonus')}</span>
                    <div className="text-center">
                      <a href="https://ilinks.com.br" target="_Blank">
                        <img src="https://ilinks.com.br/personalizar-texto/images/logo.png" width="80px"/>
                      </a>
                      <div>{t('index.planFeatures.sixMonthsPremium')}</div>
                    </div>
                  </div>
                  <hr />
                  <li className="priceMouth">
                    <div className="text-center">
                      {countryConfig.currency.symbol} <span className="oldPrice">{formatPrice(getPlanPrice('original', 'semiannual'))}</span>/{t('index.month')}
                    </div>
                    <div className="text-center">
                      {countryConfig.currency.symbol}<strong className="amount"><span className="big" id="valorMensal"> {formatPrice(getPlanPrice('discounted', 'semiannual'))}</span></strong>/{t('index.month')} 
                    </div>
                  </li>
                </ul>
                <button onClick={() => window.open(planModality === "Individual" ? "https://buy.stripe.com/4gw7vccj95kb7G8cMN" : "https://buy.stripe.com/9AQdTAfvleULbWodQU", "_self")} className="btn btn-default col-12 col-md-10">
                  <span style={{marginLeft: 5}}>{t('index.getPlan')}</span>
                </button>
                <div className="text-center" style={{paddingTop: 15, marginBottom: -18}}>
                  <span className="text-center obs">* {t('index.paymentInfo', { value: formatPrice(getPlanPrice('total', 'semiannual')), period: t('index.semiannual') })}</span>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 text-center">
              <div className="itemPlan text-center">
                <div className="text-center">
                  <img src={iconPremium} width="80"/>
                  <p className="title">{planModality === "Individual" ? t('index.monthlyPlan') : t('index.monthlyPlanTeam')}</p>
                </div>
                <hr />
                <ul className="list-unstyled text-left" style={{margin: 15}}>
                  <li><i>✔</i> {t('index.planFeatures.patientManagement')}</li> 
                  <li><i>✔</i> {t('index.planFeatures.appointmentManagement')}</li> 
                  <li><i>✔</i> {t('index.planFeatures.onlineScheduling')}</li>
                  <li><i>✔</i> {t('index.planFeatures.irisAnalysis')}</li>
                  <li><i>✔</i> {t('index.planFeatures.cloudStorage')}</li> 
                  <li><i>✔</i> {t('index.planFeatures.multipleDevices')}</li>
                  <li><i>✔</i> {t('index.planFeatures.webApp')}</li> 
                  <li><i>✔</i> {t('index.planFeatures.futureUpdates')}</li>
                  <li><i>✔</i> {planModality === "Individual" ? t('index.planFeatures.oneUser') : <b>{t('index.planFeatures.fiveUsers')}</b>}</li>
                  <li><i>✔</i> <b>{t('index.planFeatures.sevenDaysFree')}</b></li>
                  <div style={{marginTop: 10}}>
                    <span>{t('index.planFeatures.bonus')}</span>
                    <div className="text-center">
                      <a href="https://ilinks.com.br" target="_Blank">
                        <img src="https://ilinks.com.br/personalizar-texto/images/logo.png" width="80px"/>
                      </a>
                      <div>{t('index.planFeatures.thirtyDaysPremium')}</div>
                    </div>
                  </div>
                  <hr />
                  <li className="priceMouth">
                    <div className="text-center">
                      {countryConfig.currency.symbol} <span className="oldPrice">{formatPrice(getPlanPrice('original', 'monthly'))}</span>/{t('index.month')}
                    </div>
                    <div className="text-center">
                      {countryConfig.currency.symbol}<strong className="amount"><span className="big" id="valorMensal"> {formatPrice(getPlanPrice('discounted', 'monthly'))}</span></strong>/{t('index.month')} 
                    </div>
                  </li>
                </ul>
                <button onClick={() => window.open(planModality === "Individual" ? "https://buy.stripe.com/00g9Dkbf59ArbWo5kk" : "https://buy.stripe.com/eVabLsfvl9AraSk8wz", "_self")} className="btn btn-default col-12 col-md-10">
                  <span style={{marginLeft: 5}}>{t('index.getPlan')}</span>
                </button>
                <div className="text-center" style={{paddingTop: 15, marginBottom: -18}}>
                  <span className="text-center obs">* {t('index.paymentInfo', { value: formatPrice(getPlanPrice('total', 'monthly')), period: t('index.monthly')})}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
    )
  
}